import { createConfig as createProvidersEnvironmentConfig } from '#shared/util/providersEnvironment.js';

export default {
	providers: createProvidersEnvironmentConfig('dev', {
		checkout: {
			credentials: {
				apiSecret: process.env.CHECKOUT_API_SECRET_DEV
			},
			variables: {
				apiEndpoint: `${IS_SERVER ? 'https://checkout-dev.avast.com' : ''}/api/v1`
			}
		},
		pp: {
			variables: {
				apiEndpoint: 'https://pricing-api.svc.int.avast.com/api/v2/pricing'
			}
		},
		my: {
			variables: {
				apiEndpoint: 'https://my-integration-stage.ff.avast.com/v1/cart'
			}
		},
		ar: {
			variables: {
				apiEndpoint: 'https://analytics-stage.ff.avast.com/v1/payload/gpb'
			}
		},
		gen: {
			credentials: {
				genavast: {
					eStoreApiClientId: process.env.GEN_AVAST_ESTORE_CLIENT_ID_QA4,
					eStoreApiClientSecret: process.env.GEN_AVAST_ESTORE_CLIENT_SECRET_QA4,
					eStoreApiTenantId: process.env.GEN_AVAST_ESTORE_TENANT_ID_QA4,
					eStoreApiMigratedTenantId: process.env.GEN_AVAST_ESTORE_MIGRATED_TENANT_ID_QA4,
					hppApiPassword: process.env.GEN_AVAST_HPP_PASSWORD_QA4
				},
				genavg: {
					eStoreApiClientId: process.env.GEN_AVG_ESTORE_CLIENT_ID_QA4,
					eStoreApiClientSecret: process.env.GEN_AVG_ESTORE_CLIENT_SECRET_QA4,
					eStoreApiTenantId: process.env.GEN_AVG_ESTORE_TENANT_ID_QA4,
					eStoreApiMigratedTenantId: process.env.GEN_AVG_ESTORE_MIGRATED_TENANT_ID_QA4,
					hppApiPassword: process.env.GEN_AVG_HPP_PASSWORD_QA4
				}
			},
			variables: {
				genavast: {
					authApiEndpoint: 'https://login.microsoftonline.com/npeauthdev.onmicrosoft.com',
					authApiScope: 'api://middleware-service-global/qa/.default',
					eStoreApiEndpoint: 'https://buy-qa4.norton.com/estore/rest',
					hppApiEndpoint: 'https://symantecpayments-qa4.norton.com/SymHostedPaymentPage/hpp',
					paymentLibrary: 'https://test-static.norton.com/estore/hpp/avast/qa/hpp_avast.js',
					fingerprintLibrary: 'https://fpt.norton.com/fp/check.js',
					fingerprintOrganizationId: '0kcwcy1p',
					servicesEnv: 'QA4'
				},
				genavg: {
					authApiEndpoint: 'https://login.microsoftonline.com/npeauthdev.onmicrosoft.com',
					authApiScope: 'api://middleware-service-global/qa/.default',
					eStoreApiEndpoint: 'https://buy-qa4.norton.com/estore/rest',
					hppApiEndpoint: 'https://symantecpayments-qa4.norton.com/SymHostedPaymentPage/hpp',
					paymentLibrary: 'https://test-static.norton.com/estore/hpp/avast/qa/hpp_avast.js',
					fingerprintLibrary: 'https://fpt.norton.com/fp/check.js',
					fingerprintOrganizationId: '0kcwcy1p',
					servicesEnv: 'QA4'
				}
			}
		}
	})
};
